import React from "react";
import { useParams } from "react-router";
import MessageRcs from "../../../../../components/campaigns/rcs/Message";
import MessageText from "../../../../../components/campaigns/rcs/MessageText";
import { FormikProvider } from "formik";
import _Input from "../../../../../components/generic/_Input";
import _Select from "../../../../../components/generic/_Select";
import _Switch from "../../../../../components/generic/_Switch";
import { Device } from "../../../../../components/campaigns/rcs/DevicePreview";
import { useTemplatesMessage } from "../../hooks/useTemplatesMessage";
import Loading from "../../../../../components/ui/Suspense";
import _Button from "../../../../../components/generic/_Button";
import Icon from "../../../../../components/Icon";
const _DetailMessageTemplate = () => {
  const params = useParams();


  const { formik, _validate, isUpdate, isLoadingDetail, isLoading } =
    useTemplatesMessage(params?.uuid_message_template);

  if (isLoadingDetail && params?.uuid_message_template) {
    return <Loading />;
  }

  return (
    <FormikProvider value={formik}>
      {" "}
      <div className="flex justify-end py-2 gap-2">
        <_Button
          title={isUpdate ? "Actualizar" : "Guardar"}
          onClick={async () => _validate()}
          style="primary"
          loading={isLoading}
          disabled={isLoading}
          icon={isUpdate ? "update" : "save"}
        />
      </div>
      <div className="bg-white px-2 py-2 rounded-lg my-2">
        <_Input
          title="Nombre"
          value={formik.values.name}
          onChange={(e) => formik.setFieldValue("name", e.target.value)}
          placeholder="Escriba el nombre de identificación para su template"
          onBlur={formik.handleBlur}
          errors={formik.errors && formik.errors.name}
          isError={formik.errors && formik.errors.name ? true : false}
        />
        <_Select
          title="Categoria por Caso de Uso"
          value={formik.values.category}
          onChange={(e) => formik.setFieldValue("category", e.target.value)}
          options={[
            { label: "Selecciona una categoría", value: "" },
            { label: "Promocional", value: "PROMOTIONAL" },
            { label: "Contraseñas de un solo uso (OTP)", value: "OTP" },
            { label: "Multiuso", value: "MULTI-USE" },
            { label: "Transaccional", value: "TRANSACTIONAL" },
          ]}
          onBlur={formik.handleBlur}
          errors={formik.errors && formik.errors.category}
          isError={formik.errors && formik.errors.category ? true : false}
        />
        <div className="flex justify-between items-center rounded-lg px-4 py-2 border bg-gray-50 my-2">
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold text-gray-600">
              ¿Este template esta activo?
            </span>
            <Icon icon="info" />
          </div>
          <_Switch
            onChange={(value) => formik.setFieldValue("status", value)}
            checked={formik.values.status}
          />
        </div>
      </div>
      <div className="flex justify-between gap-2">
        <div className="flex flex-col space-y-2">
          <MessageRcs isTemplate />
          <MessageText isTemplate />
        </div>

        <aside className="md:col-span-5 md:sticky md:top-6 flex flex-col items-center gap-3">
          <span className="text-xs font-semibold uppercase tracking-wide text-gray-400">
            Vista previa
          </span>
          <div className="w-full rounded-3xl bg-gradient-to-b from-gray-100 to-gray-200 p-6 shadow-inner flex justify-center">
            <Device scale={"0.7"} device="galaxynote8" />
          </div>
        </aside>
      </div>
    </FormikProvider>
  );
};

export default _DetailMessageTemplate;
